var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDealer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.472,
    height: 41.498,
    viewBox: "0 0 185.472 41.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577",
    transform: "translate(19342 18485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Icon",
    transform: "translate(-19342 -18485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6896",
    "data-name": "Path 6896",
    d: "M-1346.747,495.609h-40.54V480.244h11.168v4.927h-6.388v5.512h30.98v-5.512h-1.964v1.294h-4.78v-6.22h11.524Z",
    transform: "translate(1387.287 -467.537)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6897",
    "data-name": "Path 6897",
    d: "M-1291.34,439.219h-15.207v-11.3h4.927v6.535h5.354V416.388h-10.281V398.679h15.207v11.189h-4.927v-6.422h-5.354v8.175h10.281Z",
    transform: "translate(1319.185 -398.679)",
    fill: "#f2824c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7235",
    "data-name": "Path 7235",
    d: "M101.189-14.314A5.555,5.555,0,0,0,95.4-8.508a5.555,5.555,0,0,0,5.805,5.789,5.575,5.575,0,0,0,5.481-3.924V-9.222h-6.032v2.043h3.519a2.727,2.727,0,0,1-2.757,2.011,3,3,0,0,1-3.195-3.341,2.924,2.924,0,0,1,2.968-3.243,2.384,2.384,0,0,1,2.238,1.168h3.065C105.892-12.919,103.913-14.314,101.189-14.314Zm15.973,2.465h-2.773v4.913a1.685,1.685,0,0,1-1.751,1.913A1.689,1.689,0,0,1,110.9-6.935v-4.913h-2.757v5.286c0,2.416,1.411,3.859,3.5,3.859a3.3,3.3,0,0,0,2.741-1.33V-2.8h2.773Zm1.443,4.508c0,2.854,1.768,4.67,3.973,4.67a3.2,3.2,0,0,0,2.805-1.411V-2.8h2.773v-9.049h-2.773v1.281a3.15,3.15,0,0,0-2.789-1.411C120.373-11.978,118.605-10.195,118.605-7.341Zm6.778.016a2.02,2.02,0,0,1-1.978,2.238,2.044,2.044,0,0,1-1.978-2.254,2.015,2.015,0,0,1,1.978-2.222A2.02,2.02,0,0,1,125.383-7.324ZM132.94-7c0-1.557.762-2.011,2.076-2.011h.762v-2.935a3.373,3.373,0,0,0-2.838,1.605v-1.508h-2.773V-2.8h2.773Zm3.616-.341c0,2.854,1.768,4.67,3.989,4.67A3.13,3.13,0,0,0,143.335-4.1v1.3h2.773v-12h-2.773v4.2a3.322,3.322,0,0,0-2.789-1.378C138.324-11.978,136.556-10.195,136.556-7.341Zm6.778.016a2.02,2.02,0,0,1-1.978,2.238,2.044,2.044,0,0,1-1.978-2.254,2.015,2.015,0,0,1,1.978-2.222A2.02,2.02,0,0,1,143.335-7.324Z",
    transform: "translate(-19311.402 -18456.254)",
    fill: "#f2824c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7236",
    "data-name": "Path 7236",
    d: "M1.24-2.694H4.013V-9.537L6.575-2.694H8.813l2.546-6.827v6.827h2.773V-14.078H10.872L7.71-6.2,4.516-14.078H1.24ZM20.294-6.083,18.2-11.743H15.1L18.786-3,16.71,1.6h2.984L25.37-11.743h-3Zm14.351,0c0-3.811-5.627-2.919-5.627-4.9a1.009,1.009,0,0,1,1.168-1.038A1.232,1.232,0,0,1,31.5-10.835h3c-.114-2.173-1.784-3.405-4.265-3.405-2.384,0-4.151,1.2-4.151,3.357-.032,4.038,5.659,2.9,5.659,5.011,0,.665-.519,1.07-1.33,1.07A1.305,1.305,0,0,1,29-6.1H26.051c.081,2.3,1.995,3.519,4.443,3.519C33.153-2.581,34.645-4.17,34.645-6.083ZM48.818-2.694h2.757V-7.981c0-2.432-1.443-3.859-3.681-3.859a3.64,3.64,0,0,0-3.049,1.686,3.38,3.38,0,0,0-3.081-1.686,3.192,3.192,0,0,0-2.643,1.232v-1.135H36.348v9.049h2.773V-7.608A1.639,1.639,0,0,1,40.856-9.44a1.639,1.639,0,0,1,1.735,1.832v4.913h2.757V-7.608A1.639,1.639,0,0,1,47.083-9.44a1.639,1.639,0,0,1,1.735,1.832Zm4.151-4.54c0,2.854,1.768,4.67,3.973,4.67a3.2,3.2,0,0,0,2.805-1.411v1.281H62.52v-9.049H59.748v1.281a3.15,3.15,0,0,0-2.789-1.411C54.737-11.872,52.969-10.089,52.969-7.235Zm6.778.016a2.02,2.02,0,0,1-1.978,2.238,2.044,2.044,0,0,1-1.978-2.254,2.015,2.015,0,0,1,1.978-2.222A2.02,2.02,0,0,1,59.748-7.218Zm7.557.324c0-1.557.762-2.011,2.076-2.011h.762V-11.84A3.373,3.373,0,0,0,67.3-10.235v-1.508H64.531v9.049H67.3ZM71.91-5.84c0,2.351,1.314,3.146,3.195,3.146h1.411V-5.045h-.989c-.616,0-.843-.227-.843-.762V-9.44H76.5v-2.3H74.683v-2.205H71.91v2.205h-1.1v2.3h1.1Z",
    transform: "translate(-19293.586 -18456.359)",
    fill: "#0f5a9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7234",
    "data-name": "Path 7234",
    d: "M4.213-14.31v4H.3v2.729H4.213v3.986H7.1V-7.577h3.915v-2.729H7.1v-4Z",
    transform: "translate(-19167.545 -18465.455)",
    fill: "#f2824c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Dealer",
    transform: "translate(-19195.953 -18446.502)",
    fill: "#242424",
    fontSize: 11,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dealer")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDealer);
export default __webpack_public_path__ + "static/media/Logo_Dealer.f64be886d19f07ab33fe7c41711eb732.svg";
export { ForwardRef as ReactComponent };